export enum SimonStatus {
  Waiting,
  Showing,
  Playing,
  Losed,
}
